module.exports = __webpack_public_path__ + "img/p2.50671cc.png";